import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState, selectAuthStatus } from '../store';
import { filter, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PlatformService {
  private platformId = inject(PLATFORM_ID);
  private store = inject(Store<AppState>);

  /**
   * Verifica se l'applicazione è in esecuzione nel browser
   */
  isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  /**
   * Ottiene lo stato di autenticazione gestendo automaticamente il SSR
   * Ritorna false durante il prerendering, altrimenti usa lo store
   */
  getAuthStatus$(): Observable<boolean> {
    if (this.isBrowser()) {
      return this.store.select(selectAuthStatus).pipe(
        filter(status => status.canActivate),
        map(status => status.isAuthenticated)
      );
    }
    return of(false);
  }

  /**
   * Wrapper generico per eseguire selector solo in browser
   * Durante SSR ritorna il valore di fallback
   */
  selectInBrowser$<T>(
    selector: Observable<T>,
    fallbackValue: T
  ): Observable<T> {
    return this.isBrowser() ? selector : of(fallbackValue);
  }
}

